module.exports = __webpack_public_path__ + "static/media/cas.e5369702.jpg";